import { NgModule } from "@angular/core";
import { EnumNamesPipe } from "@pipes/enum-names.pipe";
import { TranslatePipe } from "@pipes/translate.pipe";
import { VLocationPipe } from "./location.pipe";
import { VDatePipe } from "./date.pipe";
import { EnumAsString } from "./enum-as-string.pipe";
import { FormatNumberPipe } from "./format-number.pipe";
import { MinutesToDurationPipe } from "./minutes-to-duration.pipe";
import { OrderByPropPipe } from "./order-by-prop.pipe";
import { VOrdinalSuffixPipe } from "./ordinal-suffix.pipe";
import { PhoneNumberPipe } from "./phone-number.pipe";
import { VRelativeTimePipe } from "./relative-time.pipe";
import { SplitPascalCasePipe } from "./split-pascal-case";
import { VTimePipe } from "./time.pipe";
import { UnitConversionPipe } from "./unit-conversion.pipe";
import { VeriDatePipe } from "./veri-date.pipe";
import { WithLoadingPipe } from "./with-loading.pipe";

const publicDeclarations = [
    VeriDatePipe,
    TranslatePipe,
    PhoneNumberPipe,
    EnumNamesPipe,
    UnitConversionPipe,
    FormatNumberPipe,
    EnumAsString,
    VDatePipe,
    VTimePipe,
    VRelativeTimePipe,
    VOrdinalSuffixPipe,
    OrderByPropPipe,
    SplitPascalCasePipe,
    VLocationPipe,
    WithLoadingPipe,
    MinutesToDurationPipe
]

@NgModule({
    declarations: [
        ...publicDeclarations
    ],
    exports: [
        ...publicDeclarations
    ],
    providers: [
        VeriDatePipe,
        EnumNamesPipe,
        UnitConversionPipe,
        SplitPascalCasePipe
    ]
})
export class PipesModule {
    constructor() { }
}
